/** Subcollection under users for progress per exam module. Document id = examModuleId. */
export const SUBCOLLECTION_PROGRESS = 'progress';
